// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__t7L0v","imageUploader":"EGiftCard_imageUploader__768Ly"};